import { render } from "./questionAnalysisBar.vue?vue&type=template&id=52c80022&scoped=true"
import script from "./questionAnalysisBar.vue?vue&type=script&lang=js"
export * from "./questionAnalysisBar.vue?vue&type=script&lang=js"

import "./questionAnalysisBar.vue?vue&type=style&index=0&id=52c80022&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52c80022"]])

export default __exports__